"use client";

import { Button } from "@/components/ui/button";
import { buildGoogleCalendarUrl } from "@/utils/calendar";
import { CalendarPlus } from "lucide-react";

export default function AddToCalendarButton(props: {
  eventName: string;
  hostName: string;
  startDate: string;
  endDate?: string | null;
  startTime?: string | null;
  endTime?: string | null;
  locationText?: string | null;
  label: string;
  className?: string;
}) {
  const addToCalendar = () => {
    window.open(buildGoogleCalendarUrl(props), "_blank");
  };

  return (
    <Button
      variant="secondary"
      className={`rounded-full py-2 h-12 px-4 gap-2 text-sm font-medium ${props.className ?? ""}`}
      onClick={addToCalendar}
    >
      <CalendarPlus className="h-5 w-5" />
      {props.label}
    </Button>
  );
}
